<template>
  <div aria-hidden="true" class="app-hero-image-carousel" tabindex="-1">
    <Swiper v-if="slides.length" :options="swiperOptions">
      <SwiperSlide v-for="slide in slides" :key="slide.id">
        <img class="image" :src="slide.media.url" :alt="slide.media.alt" fetchpriority="high" />
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script>
export default {
  name: 'AppHeroImageCarousel',
  props: {
    slides: {
      type: Array,
      required: true,
    },
    transitionEffect: {
      type: String,
      default: 'slide',
      validator: (value) => ['slide', 'fade'].includes(value),
    },
  },
  computed: {
    swiperOptions() {
      return {
        effect: this.transitionEffect,
        speed: 1000,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-hero-image-carousel {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  background-color: vars.$c-gray-e0;

  .swiper {
    height: 100%;
  }

  .image {
    width: 100%;
    height: 100%;
    position: relative;
    object-position: 50% 30%;
    object-fit: cover;
  }
}
</style>
